import { render, staticRenderFns } from "./standardFilesRepository.vue?vue&type=template&id=d1354d12&scoped=true"
import script from "./standardFilesRepository.vue?vue&type=script&lang=js"
export * from "./standardFilesRepository.vue?vue&type=script&lang=js"
import style0 from "./standardFilesRepository.vue?vue&type=style&index=0&id=d1354d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1354d12",
  null
  
)

export default component.exports